import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BackButton = ({ redirectPage }) => {
	const navigate = useNavigate();
	return (
		<button
			className="button text size32 p-0"
			onClick={() => {
				if (redirectPage) {
					navigate(
						redirectPage.url,
						redirectPage.sourceState && { source: redirectPage.sourceState }
					);
				} else {
					navigate(-1);
				}
			}}
		>
			<img src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`} alt="back" />
		</button>
	);
};
